import {WEBFORM} from '../../utils/constants';

const getBasePath = (preferredLocale) => {
    let basePath;

    switch (preferredLocale) {
        case 'en_GB':
            basePath = '/en-gb';
            break;
        case 'en_AU':
            basePath = '/en-au';
            break;
        case 'en_NZ':
            basePath = '/en-nz';
            break;
        case 'es_ES':
            basePath = '/es-es';
            break;
        case 'it_IT':
            basePath = '/it-it';
            break;
        case 'ja_JP':
            basePath = '/ja-jp';
            break;
        case 'pt_PT':
            basePath = '/pt-pt';
            break;
        case 'pt_BR':
        case 'en_US':
        case 'de_DE':
        case 'fr_FR':
        default:
            basePath = '';
            break;
    }

    return basePath;
};

const getHostName = (environment, preferredLocale) => {
    let host;

    if (environment === 'test') {
        switch (preferredLocale) {
            case 'de_DE':
                host = 'test.fewo-direkt.de';
                break;
            case 'fr_FR':
                host = 'test.abritel.fr';
                break;
            default:
                host = 'test.vrbo.com';
                break;
        }
    } else if (environment === 'stage') {
        switch (preferredLocale) {
            case 'de_DE':
                host = 'stage.fewo-direkt.de';
                break;
            case 'fr_FR':
                host = 'stage.abritel.fr';
                break;
            default:
                host = 'stage.vrbo.com';
                break;
        }
    } else if (environment === 'prod') {
        switch (preferredLocale) {
            case 'de_DE':
                host = 'www.fewo-direkt.de';
                break;
            case 'fr_FR':
                host = 'www.abritel.fr';
                break;
            default:
                host = 'www.vrbo.com';
                break;
        }
    }

    return host;
};

const redirectToQCWebform = (webFormType, preferredLocale, environment, nodeEnvironment) => {
    if (typeof window !== 'undefined') {
        let {protocol, host} = window.location;
        let basePath;

        if (preferredLocale) {
            basePath = getBasePath(preferredLocale);
        } else {
            basePath = window.location.basePath || '';
        }

        if (environment === 'development' || (host && host.includes('test') && (preferredLocale === 'de_DE' || preferredLocale === 'fr_FR'))) {
            host = getHostName('test', preferredLocale);
        } else if ((environment === 'stage' && nodeEnvironment === 'development') || (host && host.includes('stage') && (preferredLocale === 'de_DE' || preferredLocale === 'fr_FR'))) {
            host = getHostName('stage', preferredLocale);
        } else if (preferredLocale === 'de_DE' || preferredLocale === 'fr_FR') {
            host = getHostName('prod', preferredLocale);
        }
        let appUrl = `${protocol}//${host}${basePath}${WEBFORM.prefix}${webFormType}`;

        window.location.replace(`${appUrl}`);
    }
};

const redirectToVrboLandingPage = (environment, nodeEnvironment) => {
    let appUrl;
    if (typeof window !== 'undefined') {
        let {protocol, host} = window.location;

        if (environment === 'development') {
            host = 'test.vrbo.com';
        } else if (environment === 'stage' && nodeEnvironment === 'development') {
            host = 'stage.vrbo.com';
        }
        appUrl = `${protocol}//${host}${WEBFORM.prefix}/logout`;
    }

    return appUrl;
};

const unSupportedWebformSites = (siteName) => (siteName === 'homeaway_cafr' || siteName === 'homeaway_ca' || siteName === 'homeaway_at' || siteName === 'homeaway_sg' || siteName === 'homeaway_no' || siteName === 'homeaway_se' || siteName === 'homeaway_dk' || siteName === 'homeaway_gr' || siteName === 'homeaway_nl' || siteName === 'homeaway_br' || siteName === 'homeaway_jp');

export {
    getBasePath,
    getHostName,
    redirectToQCWebform,
    unSupportedWebformSites,
    redirectToVrboLandingPage
};
